import type { AxiosInstance } from "axios";
import type { IFactoryFunctionRequest, IFactoryResponse } from "@bc-library/interface";
import { EMethod } from "@bc-library/interface";
import { API_MAIN_VERSION, BASE_URL } from "@/config/constantes";
import useAxios from "@/services/api/useAxios";

export type TTimeZone = {
  _id: number;
  display: string;
  timeZone: string;
  gmtAdjustment: string;
  value: number;
  useDaylightTime: boolean;
  winterAbbreviation?: string;
  summerAbbreviation?: string;
};

const resource = "timeZones";

const getAll =
  (axios: IFactoryFunctionRequest<TTimeZone[], undefined>) => (): IFactoryResponse<TTimeZone[]> => {
    return axios({
      method: EMethod.get,
      url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}`,
    });
  };

/** Minutes from UTC by time zone, at `at`, by the API's time zone rules. */
export type TTimeZoneOffsets = {
  at: string;
  offsets: Record<string, number>;
};

const getOffsets =
  (axios: IFactoryFunctionRequest<TTimeZoneOffsets, undefined>) => (zones: string[]): IFactoryResponse<TTimeZoneOffsets> => {
    return axios({
      method: EMethod.get,
      url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/offsets`,
      query: { zones: zones.join(",") },
    });
  };

export default (axios: AxiosInstance) => ({
  getAll: getAll(useAxios(axios)),
  getOffsets: getOffsets(useAxios(axios)),
});
